import React, { Component } from 'react';
import Breadcrumb from "../common/breadcrumb";
import User from "../../assets/icon/user.svg"
import Wallet2 from "../../assets/icon/wallet2.png"
import Edit from "../../assets/icon/edit.svg"
import AddCredit from "../../assets/icon/wallet.svg"
import Ticket from "../../assets/icon/ticket.svg"
import Tachometer from "../../assets/icon/techometer.svg"
import Transaction from "../../assets/icon/transaction.svg"
import EditUser from "../../assets/icon/edit-user.png"
import Logout from "../../assets/icon/logout.svg"
import Gallery from "../../assets/icon/gallery.svg"
class Dashboard extends Component {

    constructor(props) {
        super(props)
    }

    render() {


        return (
            <div>
                {/* <Breadcrumb title={'Dashboard'}/> */}


                {/*Dashboard section*/}
                <section className="section-b-space">
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-3 border px-0" >
                                <div className='profile-top'>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img src={User} /> <h6 >نام</h6>
                                        </div>
                                        <div>
                                            <img src={Edit} />
                                        </div>
                                    </div>
                                    <div className='mt-2 mr-4 mb-1'>
                                        <a href="#" data-lng="en">
                                            <div className='icon-box'>
                                                <img src={Wallet2} />

                                            </div>
                                            <span style={{ color: 'red' }}>

                                                0 تومان
                                            </span>
                                        </a>
                                    </div>
                                </div>
                                <div className='menu-items'>
                                    <div className='menu-item'>
                                        <div className='icon-box'>
                                            <img src={Tachometer} />

                                        </div>
                                        پیشخوان
                                    </div>

                                    <div className='menu-item'>

                                        <div className='icon-box'>
                                            <img src={AddCredit} />

                                        </div>
                                        افزودن اعتبار
                                    </div>

                                    <div className='menu-item'>

                                        <div className='icon-box'>
                                            <img src={Transaction} />

                                        </div>
                                        تراکنش ها
                                    </div>

                                    <div className='menu-item'>

                                        <div className='icon-box'>
                                            <img src={Ticket} />

                                        </div>
                                        تیکت ها
                                    </div>

                                    <div className='menu-item'>
                                        <div className='icon-box'>
                                            <img src={Logout} />

                                        </div>
                                        خروج
                                    </div>

                                </div>


                            </div>
                            <div className="col-lg-9">
                                <div className="dashboard-right">
                                    <div className="dashboard">
                                        <div className="page-title">
                                            <h2>ویرایش اطلاعات شخصی</h2>
                                        </div>
                                        <div className="welcome-msg">

                                        </div>
                                        <div className="box-account box-info">

                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="box">
                                                        <div className="box-title">
                                                            <h3>تصویر پروفایل</h3>
                                                        </div>
                                                        <div className="box-content text-center">
                                                            <img src={User} />
                                                            <div className='mt-2' style={{display:'flex',alignItems:'center',justifyContent:'center',border:'1px solid #ff8400'}}>
                                                                <img src={Gallery}/>
                                                                <h6 className='text-center mr-2' style={{color:'#ff8400'}}>انتخاب تصویر</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="box">
                                                        <div className="box-title">
                                                            <h3>تغییر موبایل</h3>
                                                        </div>
                                                        <div className="box-content">
                                                            <label htmlFor="review">موبایل</label>
                                                            <input className="form-control" type="text" placeholder="09..." required="" />
                                                            <div className='text-left'>
                                                                <a href="#" className="btn btn-secondary mt-2" style={{color:'#ffffff'}}>ثبت</a>
                                                                </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 mt-4">
                                                    <div className="box">
                                                        <div className="box-title">
                                                            <h3>اطلاعات پایه</h3>
                                                        </div>
                                                        <div className="box-content">
                                                            <form className="theme-form">
                                                                <div className="form-row">
                                                                    <div className="col-md-6">
                                                                        <label htmlFor="email">نام</label>
                                                                        <input type="text" className="form-control" id="fname"
                                                                            placeholder="نام خود را وارد کنید" required="" />
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <label htmlFor="review">نام خانوادگی</label>
                                                                        <input className="form-control" type="text" placeholder="نام خانوادگی خود را وارد کنید" required="" />
                                                                    </div>
                                                                </div>
                                                                <div className="form-row">
                                                                    <div className="col-md-6">
                                                                        <label htmlFor="email">نام کاربری</label>
                                                                        <input type="text" className="form-control" id="email"
                                                                            placeholder="نام کاربری خود را وارد کنید" required="" />
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <label htmlFor="review">رمز عبور</label>
                                                                        <input type="password" className="form-control" id="review"
                                                                            placeholder="رمز عبور خود را وارد کنید" required="" />
                                                                    </div>

                                                                </div>   <div className='text-center'>

                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                                                    <a href="#" className="btn btn-solid mt-3 float-left">ثبت نام</a>

                                            </div>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}

export default Dashboard